/* eslint-disable no-useless-catch */
import retryCallIfNeeded from '../../../restCalls';

const basePath = window.__ENV.REACT_APP_BASE_PATH || '/application';
const genesysCloudCommunicationsBase = '/api/communications/v1';

export default function GenesysCloudService(client) {
  const sendSMSRequest = async (smsData, loggedIn) => {
    try {
      const response = await retryCallIfNeeded(
        client,
        () => client.post(`${loggedIn ? genesysCloudCommunicationsBase : `${basePath}/genesyscloud`}/sms`, smsData),
      );
      const data = response?.data;
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    sendSMSRequest,
  };
}
